import axios from "axios";

const setAuthToken = (token) => {
  if (token) {
    // Apply to every axios request with Bearer prefix
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    // Delete Auth Header
    delete axios.defaults.headers.common["Authorization"];
  }
};

// Cookie utility functions
const setCookie = (name, value, days = 7) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
};

const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

// Enhanced auth token management with cookie support
const setAuthTokenWithCookie = (token) => {
  if (token) {
    // Store in localStorage (for immediate access)
    localStorage.setItem('authToken', token);
    // Store in cookie (for persistence across sessions)
    setCookie('authToken', token, 7); // 7 days
    // Set axios header
    setAuthToken(token);
  } else {
    // Clear all storage
    localStorage.removeItem('authToken');
    deleteCookie('authToken');
    setAuthToken(null);
  }
};

// Initialize auth token from storage
const initializeAuthToken = () => {
  // Try localStorage first, then cookie
  let token = localStorage.getItem('authToken') || getCookie('authToken');
  if (token) {
    setAuthToken(token);
    // Sync localStorage with cookie if needed
    if (!localStorage.getItem('authToken') && token) {
      localStorage.setItem('authToken', token);
    }
  }
  return token;
};

export default setAuthToken;
export { setAuthTokenWithCookie, initializeAuthToken, setCookie, getCookie, deleteCookie };
